import { safeGet } from '../../../../../../core/util/object';
import { formatPlanNameForDisplay, getPlanTypeOrEmptyString } from '../../util/insuranceDetails';
import Personalized from './Personalized';
import Generic from './Generic';
import { isEmpty } from '../../../../../../core/util/empty';

export default class ContentCards {
  static Personalized = Personalized;

  static Generic = Generic;

  static getCardProps = ({
    insuranceDetails,
    userProfile,
    userProfileId,
    insuranceProfile,
  }: any) => ({
    carrier:
      safeGet(insuranceProfile, null)('insurer_name') ||
      formatPlanNameForDisplay(safeGet(insuranceDetails, '')('payer.name')),

    coverageExpiration: safeGet(insuranceDetails, '')('plan.end_date'),
    deductibleAmountFamilyInNetwork: safeGet(
      insuranceDetails,

      ''
    )('summary.deductible.family.in_network.limit'),
    deductibleAmountIndividualInNetwork: safeGet(
      insuranceDetails,

      ''
    )('summary.deductible.individual.in_network.limit'),
    firstName:
      safeGet(insuranceProfile, '')('first_name') || safeGet(userProfile, '')('first_name'),

    insuranceProfileId: safeGet(userProfile, '')('insurance_profile_id'),
    outOfPocketMax: safeGet(
      insuranceDetails,

      ''
    )('summary.out_of_pocket.individual.in_network.limit'),

    planName: formatPlanNameForDisplay(safeGet(insuranceDetails, '')('plan.description')),
    planType: getPlanTypeOrEmptyString(insuranceDetails).toUpperCase(),
    userProfileId,
  });
}
